var map = {
	"./bB.png": 130,
	"./bK.png": 131,
	"./bN.png": 132,
	"./bP.png": 133,
	"./bQ.png": 134,
	"./bR.png": 135,
	"./empty.png": 68,
	"./wB.png": 136,
	"./wK.png": 137,
	"./wN.png": 138,
	"./wP.png": 139,
	"./wQ.png": 140,
	"./wR.png": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;